var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { title: _vm.modalData.title, size: "xs", withBgClickEvent: true },
    on: {
      close: function ($event) {
        return _vm.$emit("close")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "flex flex-col items-center pt-2 mb-5" },
              [
                _c("CardImage", {
                  staticClass: "mb-4 rounded-full w-52 h-52",
                  attrs: {
                    src: _vm.avatar,
                    givenName: _vm.fullName,
                    userUpdatedDate: _vm.userUpdatedDate,
                  },
                }),
                _c(
                  "p",
                  { staticClass: "font-bold text-lg truncate max-w-full" },
                  [_vm._v(_vm._s(_vm.fullName))]
                ),
              ],
              1
            ),
            _c("TagMultiselect", {
              staticClass: "mb-5",
              attrs: {
                selectedTagId: _vm.appliedTagId,
                max: 1,
                getcontainerStyle: "fullWidthInput",
              },
              on: { input: _vm.setTagId },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("ModalSectionsDivider"),
            _c(
              "div",
              { staticClass: "flex pt-5 w-full justify-end" },
              [
                _c("UiButton", {
                  staticClass: "mr-3",
                  attrs: {
                    buttonText: "Cancel",
                    variant: "outline",
                    size: "lg",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                }),
                _c("UiButton", {
                  attrs: {
                    buttonText: _vm.modalData.actionButtonText,
                    disabled: _vm.disabled,
                    size: "lg",
                    variant: "black",
                  },
                  on: { click: _vm.updateEmployeeTag },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }